import { ActionTree } from 'vuex';
import { AppState } from '@/store/app';
import { IntentsState } from '.';
import { CREATE_INTENT, DELETE_INTENT, GET_INTENT, LOAD_INTENTS, UPDATE_INTENT } from './actionTypes';
import { ADD_TO_INTENTS_CACHE, REMOVE_INTENT_FROM_CACHE, SET_INTENTS, UPDATE_INTENT_IN_CACHE } from './mutationTypes';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { nlpApi } from '@/features/bots/services/nlp';
import { SaveIntentViewModel } from '@/features/bots/models/intents/saveIntentViewModel';

export const actions: ActionTree<IntentsState, AppState> = {
  async [GET_INTENT]({ rootState, dispatch }, id: string) {
    const currentWorkspace = (rootState as any).app.currentWorkspace;
    if (!currentWorkspace) {
      return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
    }
    return await nlpApi.getIntent(currentWorkspace.id, id);
  },

  async [LOAD_INTENTS]({ commit, rootState, state, dispatch }, forceLoad?: boolean) {
    const currentWorkspace = (rootState as any).app.currentWorkspace;
    if (!currentWorkspace) {
      return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
    }

    if (state.intents.length === 0 || forceLoad) {
      const response = await nlpApi.getIntents(currentWorkspace.id);
      commit(SET_INTENTS, response);
    }

    return state.intents;
  },

  async [CREATE_INTENT]({ commit, rootState, dispatch }, intent: SaveIntentViewModel) {
    const currentWorkspace = (rootState as any).app.currentWorkspace;
    if (!currentWorkspace) {
      return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
    }

    const createdIntent = await nlpApi.addIntent(currentWorkspace.id, intent);
    commit(ADD_TO_INTENTS_CACHE, createdIntent);

    return createdIntent;
  },

  async [UPDATE_INTENT]({ commit, rootState, dispatch }, { id, intent }) {
    const currentWorkspace = (rootState as any).app.currentWorkspace;
    if (!currentWorkspace) {
      return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
    }

    const updatedIntent = await nlpApi.updateIntent(currentWorkspace.id, intent, id);

    commit(UPDATE_INTENT_IN_CACHE, updatedIntent);
    return updatedIntent;
  },

  async [DELETE_INTENT]({ commit, rootState, dispatch }, id: string) {
    const currentWorkspace = (rootState as any).app.currentWorkspace;
    if (!currentWorkspace) {
      return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
    }
    await nlpApi.deleteIntent(currentWorkspace.id, id);
    commit(REMOVE_INTENT_FROM_CACHE, id);
  },
};
